import { TFunction } from 'i18next';
import { object, string, mixed } from 'yup';

function getBaseValidationRules(t: TFunction) {
  return {
    fullName: string()
        .matches(/^(?!.*[ЫЪЭЁыъэё@%&amp;$^#])[А-ЯҐЇІЄа-яґїіє’\'\- ]+$/gi, {
          message: t('full_name_format'),
          excludeEmptyString: false,
        })
        .max(70, t('validator.maxLength', { len: 70 }))
        .required(t('required_field')),
    email: string().email(t('valid_email')).required(t('required_field')),
    phone: string()
        .matches(/^\+380[0-9]{9}$/is, t('phone_validation'))
        .required(t('required_field')),
    description: string().max(2000, t('validator.maxLength', { len: 2000 })).required(t('required_field')),
  };
}

export function getValidationForUser(t: TFunction) {
  return object().shape({
    ...getBaseValidationRules(t),
    fullName: string().notRequired(),
    email: string().notRequired(),
    phone: string().notRequired(),
  });
}

export function getValidationForGuest(t: TFunction) {
  return object().shape({...getBaseValidationRules(t)});
}
